import { apiFuns } from "sw-hic";
let { genStandard } = apiFuns;

let api = {
  DbCon: genStandard("dbCon", "/api/datacenter"),
  Module: genStandard("module", "/api/datacenter"),
  Page: genStandard("page", "/api/datacenter"),
  SiteMap: genStandard("siteMap", "/api/datacenter"),
};
export default api;
